import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useSelector } from "react-redux";

import { useStyles, CssTextField } from "./classes";

export default function SearchItems({ setFieldValue, dialogOpen }) {
  const classes = useStyles();
  const [results, setResults] = useState([]);
  const initialValues = useSelector((state) => state.showSearch.initialValues);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    loadSearchItemsList();
    // eslint-disable-next-line
  }, []);
  //load restaurants and tags
  const loadSearchItemsList = async () => {
    try {
      let { data } = await axios.get("/search");
      setResults(data);
    } catch (error) {
      //   setAlert({
      //     showAlert: true,
      //     severity: "error",
      //     message: "Loading failed!",
      //   });
      dialogOpen(true);
    }
  };
  return (
    <Grid item xs={12} sm={12} md={12} lg={12} className={classes.gapSpace}>
      <Autocomplete
        id="free-solo-demo"
        freeSolo
        open={open}
        onOpen={() => {
          if (inputValue) {
            setOpen(true);
          }
        }}
        onClose={() => setOpen(false)}
        inputValue={inputValue}
        onInputChange={(e, value, reason) => {
          setInputValue(value);

          if (!value) {
            setOpen(false);
          }
        }}
        autoComplete
        includeInputInList
        filterSelectedOptions
        defaultValue={{
          id: initialValues.id,
          name: initialValues.name,
          type: initialValues.type,
        }}
        size="small"
        onChange={(event, newValue) => {
          if (newValue) {
            const { id, type, name } = newValue;

            setFieldValue("id", id);
            setFieldValue("type", type);
            setFieldValue("name", name);
          } else {
            setFieldValue("id", null);
            setFieldValue("type", null);
            setFieldValue("name", null);
          }
        }}
        options={results}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <CssTextField
            {...params}
            className={classes.Searchinput}
            placeholder="Restaurant, Food"
            variant="outlined"
            id="custom-css-outlined-input"
            defaultValue
          />
        )}
      />
    </Grid>
  );
}
